import axios from 'axios';
import { getBrandCode } from '../app/bootstrap';










export const validators = {
    1: response => ['egift', 'physical'].includes(response.toLowerCase()),
    2: (response, faceplates) => {
        for (let i = 0; i < faceplates.length; i++) {
            if (faceplates[i].code === response) {
                return true;
            }
        }
        return false;
    },
    3: response => !Number.isNaN(response) && parseInt(response, 10) > 0,
    4: response => response.includes(' and ') && response.split(' and ').length === 2,
    5: response => response.includes(' and ') && response.split(' and ').length === 2,
    6: response => /^[0-9]{16}$/.test(response),
    7: response => /^(0[1-9]|1[0-2])\/([0-9]{2})$/.test(response),
    8: response => /^[0-9]{3,4}$/.test(response),
    9: response => response.length > 5
};

export const questions = (faceplates = null) => ({
    1: { text: 'What type of gift card do you want to order?', options: ['eGift', 'Physical'] },
    2: { text: 'Please select from available designs', faceplates },
    3: { text: 'Please enter an Amount' },
    4: { text: 'Please provide recipient name and email' },
    5: { text: 'Please provide your name and email' },
    6: { text: 'card number' },
    7: { text: 'expiry date (MM/YY)' },
    8: { text: 'card CVV' },
    9: { text: 'billing address' },
    10: { text: 'Please provide payment details:' }
});

export const placeOrder = async (orderDetails) => {
    const apiUrl = 'https://api.semi.cashstar.com/v2/order/';
    const headers = {
        'Content-Type': 'application/json',
        Authorization: 'Basic dGVzdF93YW5kZXJmdWw6REc1ZzVBWTdjcUVmWG5ZJQ==',
        'X-Mock-Accepted': true,
        Accept: 'application/json',
        Cookie: 'datadome=Ynm9Wuly1zOulgBH7OhefyGjPkxLEXsBHGfxwApVqO0INwat_TCcV1KF9WdB4t9iMAuMGS5eM3r2bkF0SvnJ6MR1EQSq7tcO2ByyZiKHqQfhoEN64xH4e3zhvRK20rx3'
    };
    const senderName = orderDetails.senderName.split(' ');
    
    
    const payload = {
        order: {
            egc: [
                {
                    merchant_code: getBrandCode(),
                    initial_balance: orderDetails.initial_balance,
                    current_balance: 0.0,
                    currency: 'USD',
                    challenge: orderDetails.recipientEmail,
                    challenge_description: 'What is your e-mail address?',
                    faceplate_code: orderDetails.faceplate_code,
                    country_issued: 'US',
                    delivery: {
                        method: 'EMAIL',
                        target: orderDetails.recipientEmail
                    }
                }
            ],
            payment: {
                amount: orderDetails.initial_balance,
                currency: 'USD',
                purchaser: {
                    first_name: senderName[0],
                    last_name: senderName[1] ? senderName[1] : '',
                    phone: '594.942.2001',
                    email: orderDetails.senderEmail
                },
                credit_card: {
                    card_type: 'VISA',
                    account_number: orderDetails.credit_card.account_number,
                    expiration_date: '0529',
                    first_name: 'Tuoglnyait',
                    last_name: 'Ubfmhugepre',
                    address: '59029  Mff6Lp Nmv',
                    address2: '',
                    city: 'CHANTILLY',
                    state_code: 'VA',
                    postal_code: '20151',
                    country_code: 'US',
                    phone: '594.942.2001',
                    email: orderDetails.senderEmail
                }
            },
            language_code: 'en-US',
            audit_number: 'H2K3CN8FP3VD5175M76A0F5555',
            activation_callback_url: 'https://f300-2405-201-7000-2065-887b-af60-bed4-55de.ngrok.io'
        },
        billing_info: {
            payment_type: 'CC',
            payment_method_id: '856676F09ED811A9'
        }
    };

    try {
        const response = await axios.post(apiUrl, payload, { headers });
        
        return response.data; 
    } catch (error) {
        console.error('Order placement failed:', error);
        throw error;
    }
};
